import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function warehouse() {
    return {
        index,
        get,
        save,
        remove,

        addService,
        updateService,
        removeService,

        addImage,
        removeImage,
        addPackage,
        updatePackage,
        removePackage,
        addDocument,
        removeDocument,
        sendEmail,
        printPdf,
        printLabel,
        printCustomLabel,
        close,
        reopen,
        status,
        deleteStatus,
        repackPackage,
        createWarehouseReceiptWithReceipt,
        repackWarehouse,

        exportWhrecFile,
        getBodyEmail
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`warehouse-receipt/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`warehouse-receipt/get?id=${id}`);
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.patch('warehouse-receipt/update', payload);
        } else {
            return axiosInstance.post('warehouse-receipt/create', payload);
        }
    }

    function remove(id) {
        return axiosInstance.delete(`warehouse-receipt/cancel`, {
            data: {
                id: id
            }
        });
    }

    function addImage(options, type = 'GALLERY') {
        const formData = new FormData();
        formData.append('id', options.id);
        formData.append('type', type);
        formData.append('files[]', options.picture);

        return axiosInstance.post('warehouse-receipt/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(imageId, warehouseReceiptId) {
        return axiosInstance.delete(`warehouse-receipt/delete-image`, {
            data: {
                warehouseReceiptId: warehouseReceiptId,
                imageId: imageId
            }
        });
    }

    function addDocument(whrecid, document) {
        const formData = new FormData();
        formData.append('documentId', whrecid);
        formData.append('file', document);
        return axiosInstance.post('warehouse-receipt/add-document', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeDocument(docId, whrId) {
        return axiosInstance.delete('warehouse-receipt/delete-document', {
            data: {
                warehouseReceiptId: whrId,
                documentId: docId
            }
        });
    }

    function sendEmail({ id, emails, body, subject }) {
        return axiosInstance.post(`warehouse-receipt/send-emails`, {
            id: id,
            emails: emails,
            body: body,
            subject: subject
        });
    }

    function printPdf(id) {
        return axiosInstance.get(`warehouse-receipt/print?whrecid=${id}`, {
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function printLabel(id) {
        return axiosInstance.get(`warehouse-receipt/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function printCustomLabel(id, formatId) {
        return axiosInstance.get(
            `warehouse-receipt/label-custom?id=${id}&labelFormatId=${formatId}`,
            {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    function close(options) {
        const formData = new FormData();
        formData.append('id', options.id);
        formData.append('comment', options['comment']);
        formData.append('sendNotification', options['sendNotification']);

        if (options['signature']) {
            formData.append(
                'signature',
                options['signature'],
                `signature_${options.id}.png`
            );
        }

        if (options['images']) {
            options.images.forEach((image) => {
                formData.append('images[]', image.file);
            });
        }

        return axiosInstance.post('warehouse-receipt/delivered', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function reopen(data) {
        return axiosInstance.post(`warehouse-receipt/reopen`, data);
    }

    function deleteStatus(statusId) {
        return axiosInstance.delete(`warehouse-receipt/delete-status`, {
            data: statusId
        });
    }

    function addPackage(warehouseReceiptId, payload) {
        const formData = new FormData();
        formData.append('warehouseReceiptId', warehouseReceiptId);

        if (Array.isArray(payload.files)) {
            payload.files.forEach((file) => {
                formData.append('files[]', file);
            });
        }

        Object.entries(payload).forEach(([key, value]) => {
            if (key === 'files') return;
            formData.append(key, value);
        });

        return axiosInstance.post('warehouse-receipt/add-receipt', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function updatePackage(warehouseReceiptId, payload) {
        return axiosInstance.patch('warehouse-receipt/update-receipt', {
            warehouseReceiptId,
            ...payload
        });
    }

    function removePackage(warehouseReceiptId, packageId) {
        return axiosInstance.delete('warehouse-receipt/remove-receipt', {
            data: {
                warehouseReceiptId,
                receiptIds: [packageId]
            }
        });
    }

    function addService(payload) {
        return axiosInstance.post('warehouse-receipt/add-services', payload);
    }

    function updateService(payload) {
        return axiosInstance.post('warehouse-receipt/update-services', payload);
    }

    function removeService(payload) {
        return axiosInstance.delete('warehouse-receipt/remove-services', {
            data: payload
        });
    }

    function status(payload) {
        return axiosInstance.post('warehouse-receipt/create-status', payload);
    }

    function repackPackage(payload) {
        const formData = new FormData();

        formData.append('shipper', payload.shipper);
        formData.append('receiver', payload.receiver);
        formData.append('agency', payload.agency?.id ?? payload.agency);
        formData.append('agent', payload.agent?.id ?? payload.agent);
        formData.append('location', payload.location?.id ?? payload.location);
        formData.append('instruction', payload.instruction ?? 'Ninguna');
        formData.append('aux', payload.aux ?? '');
        formData.append('note', payload.note ?? '');
        formData.append('sendEmailToShipper', payload.sendEmailToShipper);
        formData.append('sendEmailToConsignee', payload.sendEmailToConsignee);

        if (payload.repackingRequestId != null) {
            formData.append('repackingRequestId', payload.repackingRequestId);
        }

        if (
            Array.isArray(payload.listPackage) &&
            payload.listPackage.length > 0
        ) {
            payload.listPackage.forEach((id) => {
                formData.append('idsToReempack[]', id);
            });
        }

        payload.receiptsInWarehouseList.forEach((pkg) => {
            const format = {
                arriveDate: payload.arriveDate,
                tracking: pkg.tracking,
                description: pkg.description,
                value: pkg.value,
                weight: pkg.weight,
                length: pkg.length,
                width: pkg.width,
                height: pkg.height,
                pieces: parseInt(pkg.numberPack, 10),
                volume: pkg.volume
            };

            formData.append('receiptsInWarehouse[]', JSON.stringify(format));
        });

        return axiosInstance.post(
            'warehouse-receipt/reempack-receipts',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    function repackWarehouse(payload) {
        const formData = new FormData();

        formData.append('shipper', payload.shipper);
        formData.append('receiver', payload.receiver);
        formData.append('agency', payload.agency?.id ?? payload.agency);
        formData.append('agent', payload.agent?.id ?? payload.agent);
        formData.append('location', payload.location?.id ?? payload.location);
        formData.append('instruction', payload.instruction ?? 'Ninguna');
        formData.append('aux', payload.aux ?? '');
        formData.append('note', payload.note ?? '');
        formData.append('sendEmailToShipper', payload.sendEmailToShipper);
        formData.append('sendEmailToConsignee', payload.sendEmailToConsignee);

        if (payload.repackingRequestId != null) {
            formData.append('repackingRequestId', payload.repackingRequestId);
        }

        if (
            Array.isArray(payload.listWarehouse) &&
            payload.listWarehouse.length > 0
        ) {
            payload.listWarehouse.forEach((id) => {
                formData.append('idsToReempack[]', id);
            });
        }

        payload.receiptsInWarehouseList.forEach((pkg) => {
            const format = {
                arriveDate: payload.arriveDate,
                tracking: pkg.tracking,
                description: pkg.description,
                value: pkg.value,
                weight: pkg.weight,
                length: pkg.length,
                width: pkg.width,
                height: pkg.height,
                pieces: parseInt(pkg.numberPack, 10),
                volume: pkg.volume
            };

            formData.append('receiptsInWarehouse[]', JSON.stringify(format));
        });

        return axiosInstance.post(
            'warehouse-receipt/reempack-warehouses',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    function createWarehouseReceiptWithReceipt(data) {
        return axiosInstance.post(
            `warehouse-receipt/create-with-receipts`,
            data
        );
    }

    function exportWhrecFile(options = {}, type = 'pdf') {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            format: type
        };
        let params = {};
        let headers = {};

        if (type === 'pdf') {
            const args = options ? JSON.parse(options) : null;
            params = generateQueryParams(args.query, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            };
        } else {
            params = generateQueryParams(options, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer'
            };
        }
        return axiosInstance.get(`warehouse-receipt/export${params}`, headers);
    }

    function getBodyEmail(tableClass) {
        return axiosInstance.get(
            `warehouse-receipt/get-body-email?id=${tableClass}`
        );
    }
}
